import ChartColumnIcon from '@liquidweb-dev/undercurrent/icons/lucide/ChartColumn';
import type { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Button from '@liquidweb-dev/undercurrent/Button';
import Link from '@liquidweb-dev/undercurrent/Link';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import DialogUTM from 'components/standard/DialogUTM/DialogUTM';
// @ts-ignore
import PerformanceOptimizationImg from 'images/utm/performance-optimization.png';

interface PerformanceOptimizationProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}

const PerformanceOptimization = ({
	onClose,
	...dialogProps
}: PerformanceOptimizationProps) => {
	return (
		<DialogUTM
			{...dialogProps}
			badge={{
				icon: ChartColumnIcon,
				label: 'Performance Optimization',
			}}
			image={PerformanceOptimizationImg}
			dialogContent={{
				title: 'Keep your server running smoothly',
				description: (
					<Typography variant="body-md">
						Visit your server&apos;s <b>Monitoring tab</b> to track key metrics
						and ensure your server is healthy. Check{' '}
						<Link
							sx={({ vars }) => ({ color: vars.palette.uc.text.main })}
							href="https://www.liquidweb.com/help-docs/performance/server-optimization/cpu-performance-guide"
							target="_blank"
						>
							CPU
						</Link>
						,{' '}
						<Link
							sx={({ vars }) => ({ color: vars.palette.uc.text.main })}
							href="https://www.liquidweb.com/help-docs/performance/server-optimization/linux-memory-management/"
							target="_blank"
						>
							RAM
						</Link>
						, and network usage to keep workloads running smoothly and know when
						it&apos;s time to scale.
					</Typography>
				),
			}}
			dialogAction={
				<Button
					variant="secondary"
					size="medium"
					sx={{ alignSelf: 'flex-start' }}
					component="a"
					href="https://www.liquidweb.com/help-docs/portal/monitoring/server-monitoring-services/"
					target="_blank"
				>
					Learn more about Monitoring
				</Button>
			}
			onClose={onClose}
		/>
	);
};

export default PerformanceOptimization;
